import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { DocumentosUploadModule, FooterModule, HeaderModule, ModalComprovanteRendaModule } from '@usucampeao/ui-mobile';
import { ComprovanteRendaUploadPageRoutingModule } from './comprovante-renda-upload-routing.module';
import { ComprovanteRendaAssinaturaPage } from './comprovante-renda-upload.page';


@NgModule({
  imports: [
    // root
    CommonModule,
    IonicModule,

    // route
    ComprovanteRendaUploadPageRoutingModule,

    // components modules
    DocumentosUploadModule,
    FooterModule,
    HeaderModule,
    ModalComprovanteRendaModule,
  ],
  providers: [],
  declarations: [
    ComprovanteRendaAssinaturaPage,
    // ContratoAssinaturaTipoFisicoComponent,
  ],
})
export class ComprovanteRendaUploadPageModule { }
